import Auth from './Auth'
import Ccp from './Ccp'
import Chat from './Chat'
import Widget from './Widget'
import User from './User'
import GiftModal from './GiftModal'

// We add state to window for easy access in chrome dev tools
export const auth = new Auth()
export const ccp = new Ccp()
export const chat = new Chat()
export const widget = new Widget()
export const user = new User()
export const giftModal = new GiftModal();

